import {
  Box,
  Button,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import { useEffect, useState } from "react";
import Header from "../../../components/Header";
import { customerservice } from "../../../config";
import { executeAnyMutation } from "../../../data/DynamicServiceNew/jsondynamicservice";
import Swal from "sweetalert2";

const base_url = customerservice.uri;

const Form = (props) => {
  const customerId = localStorage.getItem("CustomerId");

  const initialValues = props.isEditing
    ? {
      id: props.data?.id || props.data?.Id,
      customerId: parseInt(customerId),
      chargeName: props.data?.ChargeName || props.data?.chargeName || "",
      chargeAmount: props.data?.ChargeAmount || props.data?.chargeAmount || "",
      chargeType: props.data?.ChargeType || props.data?.chargeType || "One-Time",
      description: props.data?.Description || props.data?.description || "",
    }
    : {
      customerId: parseInt(customerId),
      chargeName: "",
      chargeAmount: "",
      chargeType: "One-Time",
      description: "",
    };

  const validationSchema = yup.object().shape({
    chargeName: yup.string().required("Charge Name is required"),
    chargeAmount: yup.number().typeError("Must be a number").required("Charge Amount is required"),
    chargeType: yup.string().required("Charge Type is required"),
    description: yup.string().nullable(),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const chargeName = values.chargeName;
      const chargeAmount = parseFloat(values.chargeAmount);
      const chargeType = values.chargeType;
      const description = values.description;

      const variables = props.isEditing
        ? {
          id: values.id,
          customerId: parseInt(customerId),
          chargeName,
          chargeAmount,
          chargeType,
          description,
        }
        : {
          customerId: parseInt(customerId),
          chargeName,
          chargeAmount,
          chargeType,
          description,
        };

      const response = await executeAnyMutation(
        props.isEditing ? "updateCustomerCharges" : "createCustomerCharges",
        variables,
        "charge",
        false,
        base_url
      );

      if (response && !response.error) {
        props.onClose();
        props.onAction();
        await Swal.fire(
          "Success!",
          `Customer Charge has been ${props.isEditing ? "updated" : "created"
          } successfully`,
          "success"
        );
      } else {
        await Swal.fire(
          "Error",
          response?.error || "Failed to submit customer charge.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error submitting Customer Charge:", error);
    }
    setSubmitting(false);
  };

  return (
    <Box m="20px">
      <Header
        title={props.isEditing ? "Edit Customer Charge" : "Create Customer Charge"}
        subtitle={
          props.isEditing
            ? "Edit an existing charge for this customer"
            : "Create a new charge for this customer"
        }
      />

      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box display="grid" gap="30px" gridTemplateColumns="repeat(4, minmax(0, 1fr))">
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Charge Name"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.chargeName}
                name="chargeName"
                error={touched.chargeName && !!errors.chargeName}
                helperText={touched.chargeName && errors.chargeName}
                sx={{ gridColumn: "span 4" }}
              />

              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Charge Amount"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.chargeAmount}
                name="chargeAmount"
                error={touched.chargeAmount && !!errors.chargeAmount}
                helperText={touched.chargeAmount && errors.chargeAmount}
                sx={{ gridColumn: "span 4" }}
              />

              <FormControl fullWidth variant="filled" sx={{ gridColumn: "span 4" }}>
                <InputLabel id="charge-type-label">Charge Type</InputLabel>
                <Select
                  labelId="charge-type-label"
                  id="chargeType"
                  name="chargeType"
                  value={values.chargeType}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.chargeType && !!errors.chargeType}
                >
                  <MenuItem value="One-Time">One-Time</MenuItem>
                  <MenuItem value="Recurring">Recurring</MenuItem>
                  <MenuItem value="Penalty">Penalty</MenuItem>
                </Select>
              </FormControl>

              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Description"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.description}
                name="description"
                error={touched.description && !!errors.description}
                helperText={touched.description && errors.description}
                multiline
                rows={3}
                sx={{ gridColumn: "span 4" }}
              />
            </Box>

            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit"
                color="secondary"
                variant="contained"
                disabled={isSubmitting}
              >
                Save
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default Form;
